export default __webpack_public_path__ + "static/media/messageSayingThankYou.da145774.svg";